import { render, staticRenderFns } from "./DynamicFomrBuilder.vue?vue&type=template&id=024610bd"
import script from "./DynamicFomrBuilder.vue?vue&type=script&lang=js"
export * from "./DynamicFomrBuilder.vue?vue&type=script&lang=js"
import style0 from "./DynamicFomrBuilder.vue?vue&type=style&index=0&id=024610bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports